/// <amd-module name="TFS/Token/PatTokenPage/Models/Token" />
import { SessionToken } from 'Contracts/Token';

export class Token {
    private readonly initialSessionToken: SessionToken;
    public accessId: string;
    public alternateToken: string;
    public authorizationId: string;
    public clientId: string;
    public displayName: string;
    public hostAuthorizationId: string
    public isPublic: boolean;
    public isValid: boolean;
    public publicData: string;
    public scope: string;
    public source: string;
    public targetAccounts: string[];
    public userId: string;
    public validFrom: Date;
    public validTo: Date;

    constructor(sessionToken?: SessionToken) {
        if(sessionToken) {
            const { accessId, alternateToken, authorizationId, displayName, hostAuthorizationId, clientId, isValid, isPublic, scope, targetAccounts, userId, validFrom, validTo } = sessionToken;
            this.initialSessionToken = sessionToken;
            this.accessId = accessId;
            this.alternateToken = alternateToken;
            this.authorizationId = authorizationId;
            this.clientId = clientId;
            this.displayName = this.decodeHtmlSpecialChars(displayName);
            this.hostAuthorizationId = hostAuthorizationId ;
            this.isPublic = isPublic;
            this.isValid = isValid;
            this.scope = scope;
            this.targetAccounts = targetAccounts;
            this.userId = userId;
            this.validFrom = validFrom;
            this.validTo = validTo;
        }
    }

    public get token(): string {
        return this.initialSessionToken.token;
    }

    private decodeHtmlSpecialChars(str: string): string {
        const textArea = document.createElement('textarea');
        textArea.innerHTML = str;
        return textArea.value;
    }

    public toSessionToken(): SessionToken {
        return {
            ...this.initialSessionToken,
            displayName: this.displayName,
            validTo: this.validTo,
            scope: this.scope,
            targetAccounts: this.targetAccounts,
            authorizationId: this.authorizationId
        }
    }
}
